import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

function LabelType(props) {
  //Values from client
  const {
    FollowTheFlow,
    coordinateArray,
    focusedItem,
    isVerifyMode,
    isPractice,
    Completed,
    isActive,
    correctAnswerList,
    priorityActive,
    explanationClick,
    isAudioPlaying
  } = props

  //Values to client
  const {
    isImageLoaded,
    setSelectedBox,
    setFocusedItem,
    validateCorrectAnswer,
    setAnswer,
    handleExplanationChange,
    setSaveData
  } = props
  const [boxFocused, setBoxFocused] = useState(false)

  return (
    <span
      style={{
        width: '100%',
        height: '100%',
        zIndex: 90
      }}
    >
      {isImageLoaded &&
        coordinateArray.map((box, index) => {
          const {
            ControlID,
            XAxis,
            YAxis,
            Rotation,
            Width,
            CorrectAnswer,
            defaultValue,
            Height,
            Priority,
            CorrectAnswerExplanation,
            IncorrectAnswerExplanation
          } = box
          const isCorrectAnswer =
            correctAnswerList.indexOf(index) != -1 ? true : false
          // const currentActiveLabel = FollowTheFlow?
          // const isActive = FollowTheFlow
          // if (priorityActive && Priority <= priorityActive) {
          return focusedItem === index ? (
            <div
              key={ControlID.toString()}
              className='label-box-container'
              style={{
                top: YAxis,
                left: XAxis,
                width: Width.concat('%'),
                height: Height.concat('%'),
                borderStyle: isVerifyMode ? 'solid' : 'none',
                pointerEvents:
                  Completed === 1 || !isActive || isAudioPlaying
                    ? 'none'
                    : FollowTheFlow
                    ? isPractice
                      ? Priority === priorityActive
                        ? 'auto'
                        : 'none'
                      : 'auto'
                    : 'auto'
              }}
            >
              {isVerifyMode ? (
                <p
                  className={
                    defaultValue === ''
                      ? priorityActive && Priority <= priorityActive
                        ? 'orange-box'
                        : 'dotted-box'
                      : isPractice || Completed === 1 || !isActive
                      ? correctAnswerList.indexOf(index) != -1
                        ? 'green-box'
                        : 'red-box'
                      : 'black-box'
                  }
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    margin: 0,
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                  }}
                >
                  {CorrectAnswer}
                </p>
              ) : (
                <input
                  type='text'
                  autoComplete='off'
                  defaultValue={defaultValue}
                  id={'pnNo' + Priority}
                  className='input-box active-input'
                  // className={`input-box ${
                  //   correctAnswerList.indexOf(index) != -1
                  //     ? 'correct-answer'
                  //     : correctAnswerList.indexOf(index) === -1
                  //     ? 'wrong-answer'
                  //     : 'active-input'
                  // }`}
                  // className={
                  //   defaultValue !== ''
                  //     ? focusedItem === index
                  //       ? 'black-box'
                  //       : isPractice || Completed === 1 || !isActive
                  //       ? correctAnswerList.indexOf(index) != -1
                  //         ? 'green-box'
                  //         : 'red-box'
                  //       : 'black-box'
                  //     : 'black-box'
                  // }
                  // style={{
                  //   width: '100%',
                  //   textAlign: 'center',
                  //   animationName:
                  //     defaultValue !== '' &&
                  //     !boxFocused &&
                  //     focusedItem === index
                  //       ? isPractice || Completed === 1
                  //         ? correctAnswerList.indexOf(index) != -1
                  //           ? 'pulse_animation'
                  //           : 'shake_animation'
                  //         : 'flip_animation'
                  //       : 'unset',
                  //   animationDuration: '200ms'
                  // }}
                  autoFocus={
                    FollowTheFlow
                      ? priorityActive &&
                        Completed === 0 &&
                        isActive &&
                        priorityActive === Priority
                        ? true
                        : false
                      : false
                  }
                  onFocus={() => {
                    if (!explanationClick && Completed === 0 && isActive) {
                      if (isPractice && FollowTheFlow) {
                        if (correctAnswerList.indexOf(index) != -1) {
                        } else {
                          setBoxFocused(true)
                          setSelectedBox(box)
                          setFocusedItem(index)
                        }
                      } else {
                        setBoxFocused(true)
                        setSelectedBox(box)
                        setFocusedItem(index)
                      }
                    }
                  }}
                  onBlur={(event) => {
                    if (!explanationClick && Completed === 0 && isActive) {
                      if (isPractice && FollowTheFlow) {
                        if (correctAnswerList.indexOf(index) != -1) {
                        } else {
                          if (event.target.value.trim().length > 0) {
                            setAnswer(event.target.value, index)
                            validateCorrectAnswer(
                              CorrectAnswer,
                              index,
                              Priority
                            )
                          } else {
                            event.target.value =
                              coordinateArray[index].defaultValue
                          }
                          setBoxFocused(false)
                        }
                      } else {
                        if (event.target.value.trim().length > 0) {
                          setAnswer(event.target.value, index)
                          validateCorrectAnswer(CorrectAnswer, index, Priority)
                        } else {
                          event.target.value =
                            coordinateArray[index].defaultValue
                        }
                        setBoxFocused(false)
                      }
                    }
                  }}
                  onKeyDown={(ev) => {
                    if (ev.key === 'Enter') {
                      ev.target.blur()
                    } else if (ev.key === 'ArrowDown') {
                      ev.target.blur()
                    } else if (ev.key === 'Tab') {
                      if (ev.target.value.trim().length === 0) {
                        ev.preventDefault()
                        return
                      }
                    }
                  }}
                  onClick={() => {
                    if (explanationClick) {
                      if (correctAnswerList.indexOf(index) != -1) {
                        handleExplanationChange(true, CorrectAnswerExplanation)
                      } else {
                        handleExplanationChange(
                          false,
                          IncorrectAnswerExplanation
                        )
                      }
                    }
                  }}
                  readOnly={
                    Completed === 1 || !isActive
                      ? true
                      : isPractice
                      ? FollowTheFlow
                        ? Priority === priorityActive
                          ? false
                          : true
                        : false
                      : FollowTheFlow
                      ? Priority > priorityActive
                        ? true
                        : false
                      : false
                  }
                  // readOnly={
                  //   botTalking
                  //     ? true
                  //     : explanationClick
                  //     ? true
                  //     : Completed === 1 || !isActive
                  //     ? true
                  //     : isPractice
                  //     ? FollowTheFlow
                  //       ? correctAnswerList.indexOf(index) != -1
                  //         ? true
                  //         : false
                  //       : false
                  //     : false
                  // }
                />
              )}
            </div>
          ) : (
            <div
              key={ControlID.toString()}
              className='label-box-container'
              style={{
                top: YAxis,
                left: XAxis,
                transform: `rotate(${Rotation})`,
                transformOrigin: '0px 0px',
                width: Width.concat('%'),
                height: Height.concat('%'),
                borderStyle: isVerifyMode ? 'solid' : 'none',
                pointerEvents:
                  Completed === 1 || !isActive || isAudioPlaying
                    ? 'none'
                    : FollowTheFlow
                    ? isPractice
                      ? Priority === priorityActive
                        ? 'auto'
                        : 'none'
                      : 'auto'
                    : 'auto'
              }}
            >
              {isVerifyMode ? (
                <p
                  className={
                    defaultValue === ''
                      ? priorityActive && Priority <= priorityActive
                        ? 'orange-box'
                        : 'dotted-box'
                      : isPractice || Completed === 1 || !isActive
                      ? correctAnswerList.indexOf(index) != -1
                        ? 'green-box'
                        : 'red-box'
                      : 'black-box'
                  }
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    margin: 0,
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                  }}
                >
                  {CorrectAnswer}
                </p>
              ) : (
                <input
                  type='text'
                  autoComplete='off'
                  id={'pnNo' + Priority}
                  className={
                    Completed === 1 || !isActive
                      ? isCorrectAnswer
                        ? 'input-box correct-answer'
                        : 'input-box wrong-answer'
                      : isPractice
                      ? FollowTheFlow
                        ? Priority === priorityActive
                          ? defaultValue === ''
                            ? 'input-box normal-input'
                            : boxFocused === ControlID
                            ? 'input-box active-input'
                            : isCorrectAnswer
                            ? 'input-box correct-answer'
                            : 'input-box wrong-answer'
                          : Priority < priorityActive
                          ? isCorrectAnswer
                            ? 'input-box correct-answer'
                            : 'input-box wrong-answer'
                          : 'input-box inactive-input'
                        : defaultValue === ''
                        ? 'input-box normal-input'
                        : boxFocused === ControlID
                        ? 'input-box active-input'
                        : isCorrectAnswer
                        ? 'input-box correct-answer'
                        : 'input-box wrong-answer'
                      : defaultValue === ''
                      ? 'input-box normal-input'
                      : boxFocused === ControlID
                      ? 'input-box active-input'
                      : 'input-box active-input'
                  }
                  style={{
                    backgroundColor: 'white',
                    boxShadow:
                      box.BoxOverlay &&
                      `${box.BoxOverlay.shadowColorValue} 0px 0px ${box.BoxOverlay.shadowOpacity}px ${box.BoxOverlay.shadowSpread}px`
                  }}
                  // className={
                  //   isPractice && Completed === 0 && isActive
                  //     ? FollowTheFlow
                  //       ? Priority === priorityActive
                  //         ? defaultValue === ''
                  //           ? 'input-box active-input'
                  //           : boxFocused
                  //           ? 'input-box active-input'
                  //           : isCorrectAnswer
                  //           ? 'input-box correct-answer'
                  //           : 'input-box wrong-answer'
                  //         : Priority < priorityActive
                  //         ? isCorrectAnswer
                  //           ? 'input-box correct-answer'
                  //           : 'input-box wrong-answer'
                  //         : 'input-box inactive-input'
                  //       : defaultValue === ''
                  //       ? 'input-box active-input'
                  //       : boxFocused
                  //       ? 'input-box active-input'
                  //       : isCorrectAnswer
                  //       ? 'input-box correct-answer'
                  //       : 'input-box wrong-answer'
                  //     : 'input-box active-input'
                  // }
                  // className={`input-box ${ FollowTheFlow?
                  //   correctAnswerList.indexOf(index) != -1
                  //     ? 'correct-answer'
                  //     : correctAnswerList.indexOf(index) === -1
                  //     ? 'wrong-answer'
                  //     : 'active-input'
                  // }`}
                  // className={
                  //   defaultValue !== ''
                  //     ? focusedItem === index
                  //       ? 'black-box'
                  //       : isPractice || Completed === 1 || !isActive
                  //       ? correctAnswerList.indexOf(index) != -1
                  //         ? 'green-box'
                  //         : 'red-box'
                  //       : 'black-box'
                  //     : 'black-box'
                  // }
                  // style={{
                  //   width: '100%',
                  //   textAlign: 'center',
                  //   animationName:
                  //     defaultValue !== '' &&
                  //     !boxFocused &&
                  //     focusedItem === index
                  //       ? isPractice || Completed === 1
                  //         ? correctAnswerList.indexOf(index) != -1
                  //           ? 'pulse_animation'
                  //           : 'shake_animation'
                  //         : 'flip_animation'
                  //       : 'unset',
                  //   animationDuration: '200ms'
                  // }}
                  defaultValue={defaultValue}
                  autoFocus={
                    FollowTheFlow
                      ? priorityActive &&
                        Completed === 0 &&
                        isActive &&
                        priorityActive === Priority
                        ? true
                        : false
                      : false
                  }
                  onFocus={() => {
                    if (!explanationClick && Completed === 0 && isActive) {
                      if (isPractice && FollowTheFlow) {
                        if (correctAnswerList.indexOf(index) != -1) {
                        } else {
                          setBoxFocused(true)
                          setSelectedBox(box)
                          setFocusedItem(index)
                        }
                      } else {
                        setBoxFocused(true)
                        setSelectedBox(box)
                        setFocusedItem(index)
                      }
                    }
                  }}
                  onBlur={(event) => {
                    if (!explanationClick && Completed === 0 && isActive) {
                      if (isPractice && FollowTheFlow) {
                        if (correctAnswerList.indexOf(index) != -1) {
                        } else {
                          if (event.target.value.trim().length > 0) {
                            setAnswer(event.target.value, index)
                            validateCorrectAnswer(
                              CorrectAnswer,
                              index,
                              Priority
                            )
                          } else {
                            event.target.value =
                              coordinateArray[index].defaultValue
                          }
                          setBoxFocused(false)
                        }
                      } else {
                        if (event.target.value.trim().length > 0) {
                          setAnswer(event.target.value, index)
                          validateCorrectAnswer(CorrectAnswer, index, Priority)
                        } else {
                          event.target.value =
                            coordinateArray[index].defaultValue
                        }
                        setBoxFocused(false)
                      }
                    }
                  }}
                  onKeyDown={(ev) => {
                    if (ev.key === 'Enter') {
                      ev.target.blur()
                    } else if (ev.key === 'ArrowDown') {
                      ev.target.blur()
                    } else if (ev.key === 'Tab') {
                      if (ev.target.value.trim().length === 0) {
                        ev.preventDefault()
                        return
                      }
                    }
                  }}
                  onClick={() => {
                    if (explanationClick) {
                      if (correctAnswerList.indexOf(index) != -1) {
                        handleExplanationChange(true, CorrectAnswerExplanation)
                      } else {
                        handleExplanationChange(
                          false,
                          IncorrectAnswerExplanation
                        )
                      }
                    }
                  }}
                  readOnly={
                    Completed === 1 || !isActive
                      ? true
                      : isPractice
                      ? FollowTheFlow
                        ? Priority === priorityActive
                          ? false
                          : true
                        : false
                      : FollowTheFlow
                      ? Priority > priorityActive
                        ? true
                        : false
                      : false
                  }
                  // readOnly={
                  //   botTalking
                  //     ? true
                  //     : explanationClick
                  //     ? true
                  //     : Completed === 1 || !isActive
                  //     ? true
                  //     : isPractice
                  //     ? FollowTheFlow
                  //       ? correctAnswerList.indexOf(index) != -1
                  //         ? true
                  //         : false
                  //       : false
                  //     : false
                  // }
                />
              )}
            </div>
          )
          // }
        })}

      {/* {!FollowTheFlow
        ? isImageLoaded &&
          coordinateArray.map((box, index) => {
            const {
              ControlID,
              XAxis,
              YAxis,
              FontSize,
              Rotation,
              Weight,
              Width,
              CorrectAnswer,
              defaultValue,
              Height,
              CorrectAnswerExplanation,
              IncorrectAnswerExplanation
            } = box

            return focusedItem === index ? (
              <div
                key={ControlID.toString()}
                style={{
                  position: 'absolute',
                  top: YAxis,
                  left: XAxis,
                  width: Width.concat('%'),
                  height: Height.concat('%'),
                  borderStyle: isVerifyMode ? 'solid' : 'none',
                  fontSize: FontSize
                }}
              >
                {isVerifyMode ? (
                  <p
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      margin: 0,
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex'
                    }}
                    className={
                      isPractice || Completed === 1 || !isActive
                        ? correctAnswerList.indexOf(index) != -1
                          ? 'green-box'
                          : 'red-box'
                        : 'black-box'
                    }
                  >
                    {CorrectAnswer}
                  </p>
                ) : (
                  <input
                    type='text'
                    autoComplete='off'
                    defaultValue={defaultValue}
                    className={`input-box ${
                      correctAnswerList.indexOf(index) != -1
                        ? 'correct-answer'
                        : correctAnswerList.indexOf(index) === -1
                        ? 'wrong-answer'
                        : 'active-input'
                    }`}
                    // className={
                    //   defaultValue !== ''
                    //     ? focusedItem === index
                    //       ? 'black-box'
                    //       : isPractice || Completed === 1 || !isActive
                    //       ? correctAnswerList.indexOf(index) != -1
                    //         ? 'green-box'
                    //         : 'red-box'
                    //       : 'black-box'
                    //     : 'black-box'
                    // }
                    // style={{
                    //   width: '100%',
                    //   textAlign: 'center',
                    //   animationName:
                    //     defaultValue !== '' &&
                    //     !boxFocused &&
                    //     focusedItem === index
                    //       ? isPractice || Completed === 1
                    //         ? correctAnswerList.indexOf(index) != -1
                    //           ? 'pulse_animation'
                    //           : 'shake_animation'
                    //         : 'flip_animation'
                    //       : 'unset',
                    //   animationDuration: '200ms'
                    // }}
                    onFocus={() => {
                      if (!explanationClick && Completed === 0 && isActive) {
                        setBoxFocused(true)
                        setSelectedBox(box)
                        setFocusedItem(index)
                      }
                    }}
                    onBlur={(event) => {
                      if (!explanationClick && Completed === 0 && isActive) {
                        if (event.target.value.trim().length > 0) {
                          validateCorrectAnswer(CorrectAnswer, index, -1)
                          setBoxFocused(false)
                        }
                      }
                    }}
                    onChange={(event) => setAnswer(event.target.value, index)}
                    onKeyDown={(ev) => {
                      if (ev.key === 'Enter') {
                        ev.target.blur()
                      }
                    }}
                    onClick={() => {
                      if (explanationClick) {
                        if (correctAnswerList.indexOf(index) != -1) {
                          handleExplanationChange(
                            true,
                            CorrectAnswerExplanation
                          )
                        } else {
                          handleExplanationChange(
                            false,
                            IncorrectAnswerExplanation
                          )
                        }
                      }
                    }}
                    readOnly={
                      explanationClick || Completed === 1 || !isActive
                        ? true
                        : false
                    }
                  />
                )}
              </div>
            ) : (
              <div
                key={ControlID.toString()}
                style={{
                  position: 'absolute',
                  top: YAxis,
                  left: XAxis,
                  transform: `rotate(${Rotation})`,
                  transformOrigin: '0px 0px',
                  width: Width.concat('%'),
                  height: Height.concat('%'),
                  display: 'flex',
                  borderColor: '#0bff31',
                  borderWidth: '2px',
                  borderStyle: isVerifyMode ? 'solid' : 'none',
                  fontSize: FontSize
                }}
              >
                {isVerifyMode ? (
                  <p
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      margin: 0,
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex'
                    }}
                    className={
                      isPractice || Completed === 1 || !isActive
                        ? correctAnswerList.indexOf(index) != -1
                          ? 'green-box'
                          : 'red-box'
                        : 'black-box'
                    }
                  >
                    {CorrectAnswer}
                  </p>
                ) : (
                  <input
                    type='text'
                    autoComplete='off'
                    className={
                      defaultValue !== ''
                        ? focusedItem === index
                          ? 'black-box'
                          : isPractice || Completed === 1 || !isActive
                          ? correctAnswerList.indexOf(index) != -1
                            ? 'green-box'
                            : 'red-box'
                          : 'black-box'
                        : 'black-box'
                    }
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      animationName:
                        defaultValue !== '' &&
                        !boxFocused &&
                        focusedItem === index
                          ? isPractice || Completed === 1
                            ? correctAnswerList.indexOf(index) != -1
                              ? 'pulse_animation'
                              : 'shake_animation'
                            : 'flip_animation'
                          : 'unset',
                      animationDuration: '200ms'
                    }}
                    defaultValue={defaultValue}
                    onFocus={() => {
                      if (!explanationClick && Completed === 0 && isActive) {
                        setBoxFocused(true)
                        setSelectedBox(box)
                        setFocusedItem(index)
                      }
                    }}
                    onBlur={(event) => {
                      if (!explanationClick && Completed === 0 && isActive) {
                        if (event.target.value.trim().length > 0) {
                          validateCorrectAnswer(CorrectAnswer, index, -1)
                          setBoxFocused(false)
                        }
                      }
                    }}
                    onChange={(event) => setAnswer(event.target.value, index)}
                    onKeyDown={(ev) => {
                      if (ev.key === 'Enter') {
                        ev.target.blur()
                      }
                    }}
                    onClick={() => {
                      if (explanationClick) {
                        if (correctAnswerList.indexOf(index) != -1) {
                          handleExplanationChange(
                            true,
                            CorrectAnswerExplanation
                          )
                        } else {
                          handleExplanationChange(
                            false,
                            IncorrectAnswerExplanation
                          )
                        }
                      }
                    }}
                    readOnly={
                      explanationClick || Completed === 1 || !isActive
                        ? true
                        : false
                    }
                  />
                )}
              </div>
            )
          })
        : isImageLoaded &&
          coordinateArray.map((box, index) => {
            const {
              ControlID,
              XAxis,
              YAxis,
              Rotation,
              Width,
              CorrectAnswer,
              defaultValue,
              Height,
              Priority,
              CorrectAnswerExplanation,
              IncorrectAnswerExplanation
            } = box
            if (priorityActive && Priority <= priorityActive) {
              return focusedItem === index ? (
                <div
                  key={ControlID.toString()}
                  style={{
                    position: 'absolute',
                    top: YAxis,
                    left: XAxis,
                    width: Width.concat('%'),
                    height: Height.concat('%'),
                    display: 'flex',
                    borderColor: '#0bff31',
                    borderWidth: '2px',
                    borderStyle: isVerifyMode ? 'solid' : 'none'
                  }}
                >
                  {isVerifyMode ? (
                    <p
                      className={
                        defaultValue === ''
                          ? priorityActive && Priority <= priorityActive
                            ? 'orange-box'
                            : 'dotted-box'
                          : isPractice || Completed === 1 || !isActive
                          ? correctAnswerList.indexOf(index) != -1
                            ? 'green-box'
                            : 'red-box'
                          : 'black-box'
                      }
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        margin: 0,
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      {CorrectAnswer}
                    </p>
                  ) : (
                    <input
                      type='text'
                      autoComplete='off'
                      defaultValue={defaultValue}
                      id={'pnNo' + Priority}
                      className={
                        defaultValue !== ''
                          ? focusedItem === index
                            ? 'black-box'
                            : isPractice || Completed === 1 || !isActive
                            ? correctAnswerList.indexOf(index) != -1
                              ? 'green-box'
                              : 'red-box'
                            : 'black-box'
                          : 'black-box'
                      }
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        animationName:
                          defaultValue !== '' &&
                          !boxFocused &&
                          focusedItem === index
                            ? isPractice || Completed === 1
                              ? correctAnswerList.indexOf(index) != -1
                                ? 'pulse_animation'
                                : 'shake_animation'
                              : 'flip_animation'
                            : 'unset',
                        animationDuration: '200ms'
                      }}
                      autoFocus={
                        priorityActive &&
                        Completed === 0 &&
                        isActive &&
                        priorityActive === Priority
                          ? true
                          : false
                      }
                      onFocus={() => {
                        if (!explanationClick && Completed === 0 && isActive) {
                          if (isPractice && FollowTheFlow) {
                            if (correctAnswerList.indexOf(index) != -1) {
                            } else {
                              setBoxFocused(true)
                              setSelectedBox(box)
                              setFocusedItem(index)
                            }
                          } else {
                            setBoxFocused(true)
                            setSelectedBox(box)
                            setFocusedItem(index)
                          }
                        }
                      }}
                      onBlur={(event) => {
                        if (!explanationClick && Completed === 0 && isActive) {
                          if (isPractice && FollowTheFlow) {
                            if (correctAnswerList.indexOf(index) != -1) {
                            } else {
                              if (event.target.value.trim().length > 0) {
                                setAnswer(event.target.value, index)
                                validateCorrectAnswer(
                                  CorrectAnswer,
                                  index,
                                  Priority
                                )
                              } else {
                                event.target.value =
                                  coordinateArray[index].defaultValue
                              }
                              setBoxFocused(false)
                            }
                          } else {
                            if (event.target.value.trim().length > 0) {
                              setAnswer(event.target.value, index)
                              validateCorrectAnswer(
                                CorrectAnswer,
                                index,
                                Priority
                              )
                            } else {
                              event.target.value =
                                coordinateArray[index].defaultValue
                            }
                            setBoxFocused(false)
                          }
                        }
                      }}
                      onKeyDown={(ev) => {
                        if (ev.key === 'Enter') {
                          ev.target.blur()
                        } else if (ev.key === 'ArrowDown') {
                          ev.target.blur()
                        } else if (ev.key === 'Tab') {
                          if (ev.target.value.trim().length === 0) {
                            ev.preventDefault()
                            return
                          }
                        }
                      }}
                      onClick={() => {
                        if (explanationClick) {
                          if (correctAnswerList.indexOf(index) != -1) {
                            handleExplanationChange(
                              true,
                              CorrectAnswerExplanation
                            )
                          } else {
                            handleExplanationChange(
                              false,
                              IncorrectAnswerExplanation
                            )
                          }
                        }
                      }}
                      readOnly={
                        botTalking
                          ? true
                          : explanationClick
                          ? true
                          : Completed === 1 || !isActive
                          ? true
                          : isPractice
                          ? FollowTheFlow
                            ? correctAnswerList.indexOf(index) != -1
                              ? true
                              : false
                            : false
                          : false
                      }
                    />
                  )}
                </div>
              ) : (
                <div
                  key={ControlID.toString()}
                  style={{
                    position: 'absolute',
                    top: YAxis,
                    left: XAxis,
                    transform: `rotate(${Rotation})`,
                    transformOrigin: '0px 0px',
                    width: Width.concat('%'),
                    height: Height.concat('%'),
                    display: 'flex',
                    borderColor: '#0bff31',
                    borderWidth: '2px',
                    borderStyle: isVerifyMode ? 'solid' : 'none'
                  }}
                >
                  {isVerifyMode ? (
                    <p
                      className={
                        defaultValue === ''
                          ? priorityActive && Priority <= priorityActive
                            ? 'orange-box'
                            : 'dotted-box'
                          : isPractice || Completed === 1 || !isActive
                          ? correctAnswerList.indexOf(index) != -1
                            ? 'green-box'
                            : 'red-box'
                          : 'black-box'
                      }
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        margin: 0,
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      {CorrectAnswer}
                    </p>
                  ) : (
                    <input
                      type='text'
                      autoComplete='off'
                      id={'pnNo' + Priority}
                      className={
                        defaultValue !== ''
                          ? focusedItem === index
                            ? 'black-box'
                            : isPractice || Completed === 1 || !isActive
                            ? correctAnswerList.indexOf(index) != -1
                              ? 'green-box'
                              : 'red-box'
                            : 'black-box'
                          : 'black-box'
                      }
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        animationName:
                          defaultValue !== '' &&
                          !boxFocused &&
                          focusedItem === index
                            ? isPractice || Completed === 1
                              ? correctAnswerList.indexOf(index) != -1
                                ? 'pulse_animation'
                                : 'shake_animation'
                              : 'flip_animation'
                            : 'unset',
                        animationDuration: '200ms'
                      }}
                      defaultValue={defaultValue}
                      autoFocus={
                        priorityActive &&
                        Completed === 0 &&
                        isActive &&
                        priorityActive === Priority
                          ? true
                          : false
                      }
                      onFocus={() => {
                        if (!explanationClick && Completed === 0 && isActive) {
                          if (isPractice && FollowTheFlow) {
                            if (correctAnswerList.indexOf(index) != -1) {
                            } else {
                              setBoxFocused(true)
                              setSelectedBox(box)
                              setFocusedItem(index)
                            }
                          } else {
                            setBoxFocused(true)
                            setSelectedBox(box)
                            setFocusedItem(index)
                          }
                        }
                      }}
                      onBlur={(event) => {
                        if (!explanationClick && Completed === 0 && isActive) {
                          if (isPractice && FollowTheFlow) {
                            if (correctAnswerList.indexOf(index) != -1) {
                            } else {
                              if (event.target.value.trim().length > 0) {
                                setAnswer(event.target.value, index)
                                validateCorrectAnswer(
                                  CorrectAnswer,
                                  index,
                                  Priority
                                )
                              } else {
                                event.target.value =
                                  coordinateArray[index].defaultValue
                              }
                              setBoxFocused(false)
                            }
                          } else {
                            if (event.target.value.trim().length > 0) {
                              setAnswer(event.target.value, index)
                              validateCorrectAnswer(
                                CorrectAnswer,
                                index,
                                Priority
                              )
                            } else {
                              event.target.value =
                                coordinateArray[index].defaultValue
                            }
                            setBoxFocused(false)
                          }
                        }
                      }}
                      onKeyDown={(ev) => {
                        if (ev.key === 'Enter') {
                          ev.target.blur()
                        } else if (ev.key === 'ArrowDown') {
                          ev.target.blur()
                        } else if (ev.key === 'Tab') {
                          if (ev.target.value.trim().length === 0) {
                            ev.preventDefault()
                            return
                          }
                        }
                      }}
                      onClick={() => {
                        if (explanationClick) {
                          if (correctAnswerList.indexOf(index) != -1) {
                            handleExplanationChange(
                              true,
                              CorrectAnswerExplanation
                            )
                          } else {
                            handleExplanationChange(
                              false,
                              IncorrectAnswerExplanation
                            )
                          }
                        }
                      }}
                      readOnly={
                        botTalking
                          ? true
                          : explanationClick
                          ? true
                          : Completed === 1 || !isActive
                          ? true
                          : isPractice
                          ? FollowTheFlow
                            ? correctAnswerList.indexOf(index) != -1
                              ? true
                              : false
                            : false
                          : false
                      }
                    />
                  )}
                </div>
              )
            }
          })} */}
    </span>
  )
}

export { LabelType }
